<template>
  <div class="insured-dialog-form relate-dialog">
    <section class="relate-dialog__section">
      <h3 class="account-person-form__title">{{ $t("commonSearch") }}</h3>
      <div class="relate-dialog__toolbar">
        <el-select
          v-model="card"
          class="relate-dialog__select"
          filterable
          remote
          reserve-keyword
          :placeholder="$t('insuredMinChars')"
          :remote-method="RemoteMethod"
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.cardId"
            :label="item.insuredName"
            :value="item"
          />
        </el-select>
        <button
          v-if="showAddButton"
          type="button"
          class="insured-dialog-btn insured-dialog-btn--primary relate-dialog__action"
          :disabled="!card"
          @click="AddCard"
        >
          {{ $t("commonAdd") }}
        </button>
      </div>
    </section>

    <section class="relate-dialog__section">
      <div v-if="resList.length" class="relate-dialog__list">
        <div v-for="list in resList" :key="list.insuredDependantId" class="relate-dialog__item">
          <span class="relate-dialog__item-name">{{ list.dependantInsuredName }}</span>
          <el-button type="danger" :icon="Delete" text @click="DropCard(list.insuredDependantId)" />
        </div>
      </div>
      <div v-else class="relate-dialog__empty">{{ $t("insuredFamilySearchEmpty") }}</div>
    </section>

    <div class="insured-dialog-footer">
      <button type="button" class="insured-dialog-btn insured-dialog-btn--muted" @click="$emit('close')">
        {{ $t("commonCancel") }}
      </button>
      <button
        v-if="resList.length > 0"
        type="button"
        class="insured-dialog-btn insured-dialog-btn--primary"
        @click="Insert"
      >
        {{ $t("commonInsert") }}
      </button>
    </div>
  </div>
</template>

<script>
import { getCardId } from "@/project/Source/routes";
import { Delete } from "@element-plus/icons-vue";
import Source from "../../Source/claim.js";

export default {
  name: "RelateDialog",
  props: {
    policyId: Number,
    isEmployee: Boolean,
    insuredName: String,
  },
  data() {
    return {
      Delete,
      list: [],
      resList: [],
      cardId: getCardId(this.$route),
      searched: false,
      options: [],
      card: null,
      loading: false,
    };
  },
  computed: {
    showAddButton() {
      return !(!this.isEmployee && this.resList.length > 1);
    },
  },
  methods: {
    DropCard(cardId) {
      this.resList = this.resList.filter((item) => item.insuredDependantId != cardId);
    },
    RemoteMethod(query) {
      if (query) {
        if (query.length == 3 || (this.searched == false && query.length > 3)) {
          const dataNum = {
            requestCorrelationId: Date.now().toString(36) + Math.random().toString(36).substr(2),
            search: query,
            isEmployee: this.isEmployee,
            policyId: this.policyId,
          };
          this.loading = true;
          Source.PolicyCardActive(dataNum)
            .then((response) => {
              this.list = response.data.data;
              this.options = this.list.filter((item) => {
                return item.insuredName.toLowerCase().includes(query.toLowerCase());
              });
              this.searched = true;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else if (query.length > 3) {
          setTimeout(() => {
            this.options = this.list.filter((item) => {
              return item.displayName.toLocaleLowerCase("az-AZ").includes(query.toLocaleLowerCase("az-AZ"));
            });
          }, 1000);
        } else {
          this.options = [];
          this.searched = false;
        }
      } else {
        this.options = [];
      }
    },
    AddCard() {
      if (!this.card) {
        return;
      }
      this.resList.push({
        insuredDependantId: this.card.insuredId,
        dependantInsuredName: this.card.insuredName,
      });
      this.card = null;
      this.options = [];
    },
    Insert() {
      let data;
      if (this.isEmployee) {
        data = {
          requestCorrelationId: "string",
          cardId: this.cardId,
          dependants: this.resList,
        };
      } else {
        data = {
          requestCorrelationId: "string",
          cardId: this.resList[0].insuredDependantId,
          dependants: [
            {
              dependantInsuredName: this.insuredName,
              insuredDependantId: this.cardId,
            },
          ],
        };
      }

      Source.NewPolicyInsuredDependantRequest(data).then(() => {
        this.$emit("insert");
      });
    },
  },
};
</script>
